<template>
  <div class="playout-load-dashboard">
    <div class="row">
      <div class="col-lg-12">
        <div class="metric-text" v-if="average">
          <span class="metric-text-title">Average:</span>
          <span>{{Math.round(average)}} minutes per hour</span>
        </div>

        <div class="metric-text" v-if="max">
          <span class="metric-text-title">Maximum:</span>
          <span>{{max.value}} minutes, on {{max.date}}</span>
        </div>
      </div>
    </div>
    <br/>
    <div class="chart-container" style="min-height: 380px">
      <line-chart
        class="chart"
        style="min-height: 380px;"
        :showLegend="showLegend"
        :data="trendData"
        :title="title"
        :labels="labels"
        :showGridLines="showGridLines"
        :yAxeslabelString="yAxeslabelString"
        :xAxeslabelString="xAxeslabelString"
      ></line-chart>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart';

export default {
  name: 'PlayoutLoad',

  props: {
    data: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: '1',
    },
    showLegend: {
      type: Boolean,
      default: false,
    },
    showGridLines: {
      type: Boolean,
      default: false,
    },
    station: {
      type: String,
      default: 'undefined',
    },
    comparedStaton: {
      type: String,
      default: 'undefined',
    },
    yAxeslabelString: {
      type: String,
      default: '',
    },
    xAxeslabelString: {
      type: String,
      default: '',
    },
  },

  computed: {

    labels() {
      return [this.station, this.comparedStaton];
    },

    average() {
      if (!this.data.length) return null;
      const total = this.data.reduce((a, x) => a + x.value, 0);
      const hours = this.data.reduce((a, x) => a + x.hours, 0);
      return total / hours;
    },

    max() {
      if (!this.data.length) return null;
      const max = Math.max(...this.data.map(x => x.value));
      return this.data.find(x => x.value === max);
    },

    trendData() {
      return this.data.map(x => x.map(y => [y.date, y.value]));
    },
  },

  components: { LineChart },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/style/_variables_live.scss';

.playout-load-dashboard {
  width: 100%;
  height: 100%;
}

.metric-text {
  font-size: 0.9em;

  .metric-text-title {
    color: $colony-purple;
    font-weight: bold;
  }
}

.chart-container {
  position: relative;
  height: 180px;
  margin-top: 42px;
}

.chart {
  position: absolute;
  width: 100%;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// PlayoutLoad.vue?6c156d75